/** @jsx jsx */
import React, { useState, useCallback, useRef } from 'react';
import { jsx } from '@emotion/core';
import { Collapse, Portal } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import InlineButton from 'components/InlineButton';
import styles from './styles';

interface PropTypes {
  collapsedTitle: string;
  expandedTitle: string;
  expandAbove?: boolean;
  addIcon?: boolean;
  id: string;
  className?: string;
}

const ExpandableLink: React.FC<PropTypes> = props => {
  const {
    expandedTitle,
    collapsedTitle,
    children,
    expandAbove,
    addIcon = false,
    id,
    className,
  } = props;
  const [open, setOpen] = useState<boolean>(false);

  const title = open ? expandedTitle : collapsedTitle;
  const toggle = useCallback(() => {
    setOpen(open => !open);
  }, [setOpen]);

  const container = useRef(null);

  return (
    <div className={className}>
      <div ref={container}></div>
      <InlineButton
        css={styles.button}
        title={title}
        onClick={toggle}
        aria-expanded={open}
        aria-controls={id}
        type="button"
      >
        <span css={styles.row}>
          {title}
          {!addIcon ? null : open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </span>
      </InlineButton>

      <Portal disablePortal={!expandAbove} container={container.current}>
        <div id={id} aria-hidden={!open}>
          <Collapse in={open} css={styles.collapsibleContainer}>
            {children}
          </Collapse>
        </div>
      </Portal>
    </div>
  );
};

export default ExpandableLink;
